import React, { createContext, useContext, useEffect } from "react";

import "./styles/wellperformance.css";
import "./styles/resizable.css";
import "./styles/grid-layout.css";
import { Layout, notification, Radio, Tooltip } from "antd";
import { CommandBar } from "@fluentui/react";
import { ProgressIndicator } from "@fluentui/react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";

import { Select } from "antd";
import WellPerformanceStore from "../wellperformance/store/WellPerformanceStore";
import { Observer, observer } from "mobx-react-lite";

import { Responsive, WidthProvider } from "react-grid-layout";

import MainStore from "../../home/store/mainStore";
import { OilWellPerformanceChart } from "./OilWellPerformanceChart";
import { GasWellPerformanceChart } from "./GasWellPerformance";

const { Content } = Layout;
const ResponsiveGridLayout = WidthProvider(Responsive);

const wellPerformanceStoreCtx = createContext(WellPerformanceStore);

const { Option } = Select;

const mainStoreCtx = createContext(MainStore);
export const WellPerformanceBaseView = observer(() => {
  const wellPerformanceStore = useContext(wellPerformanceStoreCtx);
  const mainStore = useContext(mainStoreCtx);

  useEffect(() => {
    async function loadUniqueWellData() {
      try {
        await wellPerformanceStore.getuniqueWellsData();
        await wellPerformanceStore.getWellPlotData();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadUniqueWellData();
    mainStore.resetAssetContext();
  }, []);

  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #6a3283",
      }}
    >
      <Content>
        {" "}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "1",
                    onRender: () => (
                      <div style={{ paddingTop: "5px" }}>
                        <Observer>
                          {() => (
                            <SubPageHeaderTitle
                              title={`${wellPerformanceStore.selectedWell} Performance Visualization`}
                            />
                          )}
                        </Observer>
                      </div>
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "5",
                    onRender: () => (
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm5">
                            <Tooltip title="Toogle well selection to load all the wells or only the currently producing wells">
                              <Radio.Group
                                defaultValue={true}
                                buttonStyle="solid"
                                size="small"
                                onChange={async (e) => {
                                  wellPerformanceStore.isproducing =
                                    e.target.value;
                                  await WellPerformanceStore.getuniqueWellsData();
                                }}
                              >
                                <Radio.Button value={true}>
                                  Producing Wells
                                </Radio.Button>
                                <Radio.Button value={false}>
                                  All Wells
                                </Radio.Button>
                              </Radio.Group>
                            </Tooltip>
                          </div>
                          <div className="ms-Grid-col ms-sm7">
                            {
                              <Observer>
                                {() => (
                                  <>
                                    <Select
                                      showSearch
                                      style={{ width: 300 }}
                                      placeholder="Select a Well"
                                      value={wellPerformanceStore.selectedWell}
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                      onChange={async (value) => {
                                        wellPerformanceStore.selectedWell =
                                          value;
                                        await wellPerformanceStore.getWellPlotData(
                                          value
                                        );
                                      }}
                                    >
                                      {wellPerformanceStore.uniqueWells.map(
                                        (y) => (
                                          <Option value={y} key={y}>
                                            {y}
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </>
                                )}
                              </Observer>
                            }
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
              ></CommandBar>
            </div>
          </div>
          <div
            className="ms-Grid-row"
            style={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          ></div>

          {wellPerformanceStore.isLoadingWells && (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm8"></div>
              <div className="ms-Grid-col ms-sm4">
                {" "}
                <ProgressIndicator
                  description={`loading,${
                    wellPerformanceStore.isproducing
                      ? "Producing Wells"
                      : "All Wells"
                  } `}
                />
              </div>
            </div>
          )}
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ResponsiveGridLayout
                className="layout"
                draggableCancel=".chart-container-control, .chart-container-controls, .highcharts-container, .highcharts-contextmenu, .highcharts-menu"
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rowHeight={100}
              >
                <div
                  key="1"
                  data-grid={{ x: 0, y: 0, w: 12, h: 4 }}
                  className=" ms-motion-fadeIn"
                >
                  <OilWellPerformanceChart />
                </div>

                <div
                  key="4"
                  data-grid={{ x: 0, y: 1, w: 12, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <GasWellPerformanceChart />
                </div>
              </ResponsiveGridLayout>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

